import { Guid } from '@web/utils';
import { MultimediaType } from '../../shared/enums/multimedia-type';
import { isImageType } from '../../shared/api/helpers/is-image-type';

export class AdminMultimediaCollectionItem {
  public readonly isImage: boolean;

  public constructor(
    public readonly id: Guid,
    public readonly filename: string,
    public readonly createdAt: Date,
    public readonly alt: string,
    public readonly thumbnailUrl: string,
    public readonly extension: string,
    public readonly size: number,
    public readonly type: MultimediaType,
    public readonly canBeEdited: boolean,
    public readonly canBeRemoved: boolean,
  ) {
    this.isImage = isImageType(this.type);
  }
}
